/**
 * Các giá trị đang fix cứng trên chương trình
 * NVTUAN1 11.08.2022
 */
export default {
  AllText: '<<Tất cả>>', //Text "<<Tất cả>>",
  AllStandardText: 'Tất cả', //Text "Tất cả",
  SummaryText: '<<Tổng hợp>>', //Text "<<Tổng hợp>>" trong combobox
  SummaryStandardText: 'Tổng hợp', //Text "Tổng hợp" trong combobox
  AllBudgetSourceId: 'a0624cfa-d105-422f-bf20-11f246704dc3', //Id nguồn tất cả
  SummaryStockId: 'DC36CE47-F62C-41DB-A3EE-184211CBC405', // Id kho tổng hợp
  AllStockId: '4DBE311F-9E4A-11EE-B730-005056B30259', //Id kho tất cả
  AllInventoryCategoryId: 'c13a0f3e-1d45-11ed-a597-005056b30259', // Id loại vật tư hàng hóa
  AllFixedAssetCategoryId: '068643bc-85c6-11ed-be2c-005056b30259', // Id loại tài sản cố định
  AllDepartmentId: '1D496496-AEB2-4EA9-8F1A-5859227AC7E6', // ID tất cả phòng ban
  SummaryFixedAssetCategoryId: 'CCEE2898-3703-46AA-A6BC-1A27B65D0AC1', // ID tổng hợp Loại tài sản cố định
  GuidEmpty: '00000000-0000-0000-0000-000000000000', // Guid Empty
  TemplateAllId: '00000000-0000-0000-0000-000000000000', // Mẫu bảng lương tất cả
  TemplateCoefficientId: '9A039DA6-D478-4132-8D47-48E7F4BA0CD6', // Mẫu bảng lương (mẫu hệ số)
  RefNoOPN: 'OPN', //Số chứng từ số dư ban đầu
  TaxReductionPeriod: '2024-12-31', // Ngày hết hạn giảm trừ thuế
  DBStartDateNewRegime: '2025-01-01', // ngày bắt đầu dl chế độ mới
  DateMin: '1970-01-01', // ngày nhỏ nhất có thể nhập
  DateMax: '2100-12-31', // ngày lớn nhất có thể nhập
  DateMaxTT107: '2024-12-31', // ngày lớn nhất có thể nhập
  /** NVTUAN1 29.02.2024 Danh sách các chứng từ không có chức năng ghi sổ */
  ListVoucherNotPosted: [
    563, //Rút dự toán chuyển khoản lương, bảo hiểm
    562, //Rút dự toán tiền gửi
    55, //Rút dự toán chuyển khoản
    54, //Rút dự toán tiền mặt
    66, //Bảng kê chứng từ khác
    65, //Bảng kê chứng từ thanh toán ghi thu - ghi chi 
    70, //Bảng kê chứng từ thanh toán thực chi 
    606, //Số dư ban đầu cam kết chi
    73, //Dự toán giữ lại
    115, //Kiểm kê quỹ
    204, //Điều chỉnh tồn kho
    501, //Bảng tổng hợp ngày nghỉ / làm thêm, làm đêm
    505, //Thu nhập không thường xuyên
    506, //Khấu trừ không thường xuyên
    509, //Truy lĩnh nâng lương
    508, //Truy lĩnh nâng mức lương tối thiểu
    502, //Bảng lương
    510, //Bảng tính thuế
    701, //Hóa đơn
    702, //Hóa đơn thay thế
    703, //Hóa đơn điều chỉnh tăng
    704, //Hóa đơn điều chỉnh giảm
    705, //Hóa đơn điều chỉnh thông tin
    706, //Hủy hóa đơn
    707, //Biên lai
    708, //Vé điện tử
    407, //Chứng từ ghi sổ
    406, //Bảng tổng hợp chứng từ kế toán cùng loại
  ],
  //NVTUAN1 12.04.2024: Mảng config các property mặc định luôn có ở màn danh sách tree
  ListPropertyTreeDefault: ['isGridTree', 'type', 'level', 'isSelected', '_isSelectedMultiple', '_expandable', 'childNodes', 'isParent', 'expanded', 'isHide', 'parentNode', '__vKeyValue'],
};
